import { LOCAL_STORAGE_KEY } from '@core/configs';

export const LocalStorageKey = {
  USER_SESSION: 'user_session',
  SESSION_LOGIN: 'SESSION_LOGIN',
  USER_LOG: 'USER_LOG',
  NO_PERMISSION: 'NO_PERMISSION'
};

export const KeyTriggerSession = {
  REMOVE_TOKEN: 'REMOVE_TOKEN',
  SET_TOKEN: 'SET_TOKEN'
};

export const ConstantOfTriggerSession = {
  SET_TOKEN: 'SET_TOKEN'
};

export class LocalStorageHelper {
  public static setUserSession(value: any): void {
    this.setItem(LocalStorageKey.USER_SESSION, value);
  }

  public static getAccessToken(): string | null {
    const userSession = this.getUserSession();
    return userSession ? userSession.accessToken : null;
  }

  public static getRefreshToken(): string | null {
    const userSession = this.getUserSession();
    return userSession ? userSession.refreshToken : null;
  }

  public static getUserSession(): any | null {
    try {
      const data = JSON.parse(localStorage.getItem(LocalStorageKey.USER_SESSION) || 'null');
      if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
        return data;
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  /**
   * Custom localStorage.setItem
   */
  public static getItem(key: string) {
    const data = JSON.parse(localStorage.getItem(key) || 'null');
    if (data === 'undefined' || data === 'null') {
      return null;
    }
    return data;
  }

  /**
   * Custom localStorage.setItem
   */
  public static setItem(key: string, value: any): void {
    const data = JSON.stringify(value);
    localStorage.setItem(key, data);
  }

  /**
   * Custom localStorage.removeItem
   */
  public static removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public static clearAll(): void {
    localStorage.clear();
  }

  public static trigger(key: string) {
    this.setItem(key, true);
    this.removeItem(key);
  }

  public static triggerSessionWhenLogOut() {
    this.trigger(KeyTriggerSession.REMOVE_TOKEN);
  }

  public static getKeys(): string[] {
    return Object.keys(localStorage);
  }

  public static clear(exclude: string[] = []) {
    if (exclude.length === 0) {
      localStorage.clear();
    } else {
      this.getKeys().forEach(key => {
        if (!exclude.includes(key)) {
          this.removeItem(key);
        }
      });
    }
  }

  public static setQueryParams(value: object): void {
    this.setItem(LOCAL_STORAGE_KEY.params, JSON.stringify(value));
  }

  public static getQueryParams() {
    const query = this.getItem(LOCAL_STORAGE_KEY.params);
    return query ? JSON.parse(query) : null;
  }

  public static removeQueryParams(): void {
    this.removeItem(LOCAL_STORAGE_KEY.params);
  }

  public static getUserLogs() {
    const logs = localStorage.getItem(LocalStorageKey.USER_LOG);
    return logs ? JSON.parse(logs) : [];
  }

  public static removeUserLogs() {
    localStorage.removeItem(LocalStorageKey.USER_LOG);
  }

  public static setModuleIdAtPermDefaultDetail(moduleId: number) {
    localStorage.setItem(LOCAL_STORAGE_KEY.moduleIdAtPermDefaultDetail, moduleId.toString());
  }

  public static getModuleIdAtPermDefaultDetail() {
    const stringModuleId = localStorage.getItem(LOCAL_STORAGE_KEY.moduleIdAtPermDefaultDetail);
    return stringModuleId ? parseInt(stringModuleId) : null;
  }

  public static setPermDefaultId(permDefaultDetailId: string) {
    localStorage.setItem(LOCAL_STORAGE_KEY.permDefaultDetailId, permDefaultDetailId);
  }

  public static getPermDefaultId() {
    return localStorage.getItem(LOCAL_STORAGE_KEY.permDefaultDetailId);
  }
}
